<div class="pt-3 pl-md-4" *ngIf="configNotFound">
  <h2>Gifting config not found</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="loadingExistingConfig">
  <h2>Loading gifting config...</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="!myAccount.is_organization_admin">
  <h2>
    You do not have permission to
    {{ isNewConfig ? 'create' : 'edit' }}
    voucher pack gifting configurations.
  </h2>
</div>

<div *ngIf="(serverError === null) && !configNotFound && !loadingExistingConfig && myAccount.is_organization_admin">
  <nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a routerLink="/gifting-config" class="nav-link arrow-link">&#8592;</a>
      </li>
    </ul>

    <ul class="navbar-nav mx-auto">
      <!-- No internal navigation (yet) for gifting configs -->
    </ul>

    <form class="form-inline">
      <button class="btn btn-danger btn-sm ml-2"
              *ngIf="!isNewConfig"
              [class.disabled]="isLoading()" [disabled]="isLoading()"
              type="button" (click)="handleDelete()">
        {{ loadingDelete ? 'Deleting...' : 'Delete' }}
      </button>
      <button class="btn btn-primary btn-sm ml-2"
              [class.disabled]="isLoading()" [disabled]="isLoading()"
              type="button" (click)="handleSubmit()">
        {{ loadingSubmit ? 'Saving...' : 'Save' }}
      </button>
    </form>
  </nav>

  <div class="capitan-sub-nav-post-content">
    <div class="alert floating-alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="pt-3 pl-md-4 pb-5">
      <h2>
        {{ isNewConfig ? 'New Voucher Pack Gifting Config' : 'Edit Voucher Pack Gifting Config' }}
      </h2>

      <form (submit)="handleSubmit()">
        <div class="row mt-3">
          <div class="col-lg-10 col-xl-8">

            <div class="form-group">
              <label class="mb-1">Voucher Packs This Gifting Config Applies To</label>
              <span *ngIf="loadingVoucherPacks" class="text-muted"><br> Loading...</span>
              <ng-container *ngIf="!loadingVoucherPacks">
                <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                        *ngIf="!allVoucherPacksAreSelected()"
                        (click)="setAllVoucherPacksSelected()">
                  Select All
                </button>
                <button class="btn btn-link btn-sm p-0 ml-3" style="vertical-align: unset"
                        *ngIf="allVoucherPacksAreSelected()"
                        (click)="setNoVoucherPacksSelected()">
                  Deselect All
                </button>
                <div class="form-check" *ngFor="let voucherPack of getFilteredVoucherPacks()">
                  <input class="form-check-input" type="checkbox" id="voucherPackCheckbox{{ voucherPack.id }}"
                         [checked]="voucherPackSelected(voucherPack)"
                         (click)="toggleVoucherPack(voucherPack)">
                  <label class="form-check-label" for="voucherPackCheckbox{{ voucherPack.id }}">
                    {{ voucherPack.name }}
                    <span *ngIf="voucherPack.status === VoucherPackStatus.draft">(Draft)</span>
                    <span *ngIf="voucherPack.status === VoucherPackStatus.retired">(Retired)</span>
                  </label>
                </div>
              </ng-container>
              <small class="form-text text-muted">
                Only prepaid individual voucher pack types may be gifted. Only voucher packs in the Draft or Active state will appear in this list.
              </small>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="max_future_delivery_date_days">
                    How far in advance can a customer schedule the delivery date?
                  </label>
                  <div class="input-group">
                    <input type="number"
                           min="0" max="366" step="1"
                           id="max_future_delivery_date_days"
                           name="max_future_delivery_date_days"
                           class="form-control"
                           [(ngModel)]="giftingConfig.max_future_delivery_date_days"
                           (ngModelChange)="unsavedChanges = true">
                      <div class="input-group-append">
                        <span class="input-group-text">days</span>
                      </div>
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                Customers may purchase a gift for delivery on a future date (for example, as a birthday present). This setting restricts how far in the future that date may be. If this is set to 0, customers will only be able to purchase gifts for immediate delivery.
              </small>
              <div class="form-text text-danger">{{ errors.max_future_delivery_date_days }}</div>
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-lg-6 col-md-8">
                  <label for="expiration_days">
                    Once delivered, how many days does the gift recipient have to redeem the gift?
                  </label>
                  <div class="input-group">
                    <input type="number"
                           min="1" max="366" step="1"
                           id="expiration_days"
                           name="expiration_days"
                           class="form-control"
                           [(ngModel)]="giftingConfig.expiration_days"
                           (ngModelChange)="unsavedChanges = true">
                      <div class="input-group-append">
                        <span class="input-group-text">days</span>
                      </div>
                  </div>
                </div>
              </div>
              <small class="form-text text-muted">
                Customers must redeem the gift before it expires. If the voucher pack has a configured expiration period, that period begins when the gift is redeemed.
              </small>
              <div class="form-text text-danger">{{ errors.expiration_days }}</div>
            </div>

            <div class="form-group row">
              <div class="col-lg-10">
                <label>Terms and Conditions (for the gift giver)</label>
                <app-markdown-editor [id]="'giverTsAndCs'"
                                     [(content)]="giftingConfig.gift_giver_terms_and_conditions"
                                     (contentChange)="unsavedChanges = true"
                                     [shortEditor]="true"></app-markdown-editor>
                <small class="form-text text-muted">
                  This text will be shown alongside a checkbox. The customer buying the gift must agree to the terms and conditions before completing the purchase.
                  <br>
                  <i>
                    Note: these terms do not replace the terms and conditions that are already included on the voucher pack. If the voucher pack has separately configured terms and conditions, the gift giver must agree to both.
                  </i>
                </small>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-lg-10">
                <label>Terms and Conditions (for the gift recipient)</label>
                <app-markdown-editor [id]="'recipientTsAndCs'"
                                     [(content)]="giftingConfig.gift_recipient_terms_and_conditions"
                                     (contentChange)="unsavedChanges = true"
                                     [shortEditor]="true"></app-markdown-editor>
                <small class="form-text text-muted">
                  This text will be shown alongside a checkbox. The recipient must agree to the terms and conditions before redeeming the gift. These terms and conditions will additionally be included in the gift email.
                  <br>
                  <i>
                    Note: these terms do not replace the terms and conditions that are already included on the voucher pack. If the voucher pack has separately configured terms and conditions, the gift recipient must agree to both.
                  </i>
                </small>
              </div>
            </div>

          </div>
        </div>
      </form>
    </div>
  </div>
</div>
